import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Table } from "reactstrap";
import { useEffect, useState } from "react";
import axios from "axios";

const AnexosAbastecimiento = ({ id }) => {
  const [list1, setList1] = useState([]);
  const [open, setOpen] = useState(false);

  const toggle = () => setOpen(!open);

  useEffect(() => {
    if (!open) return; // Solo cargar datos cuando el modal se abre

    const url = "https://contratosback.azurewebsites.net/api/v1/ObtenerDocumentosAnexos/" + id;

    axios({
      auth: {
        username: "admin.icontec@icontec.org",
        password: "quAngEraMuSTerGerEDE",
      },
      method: "get",
      url,
    })
      .then((resp) => setList1(resp.data))
      .catch((err) => console.log(err));
  }, [open, id]);

  return (
    <>
      {/* Botón que abre el modal */}
      <button
        color="primary"
        onClick={toggle}
        style={{
          padding: "5px 5px",
          fontSize: "10px",
        }}
      >
        Ver Anexos
      </button>

      <Modal isOpen={open} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>Información de los Anexos</ModalHeader>

        <ModalBody>
          <Table responsive>
            <thead>
              <tr>
                <th>Id</th>
                <th>Nombre</th>
                <th>URL</th>
              </tr>
            </thead>
            <tbody>
              {list1.map((item) => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>{item.nombre}</td>
                  <td>
                    <a href={item.archivo} target="_blank" rel="noopener noreferrer">
                      Descargar Archivo
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default AnexosAbastecimiento;
